var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import '@bit/smartworks.unity.unity-core/unity-global-nav-base';
export default class UnityGlobalNav extends Component {
    constructor() {
        super(...arguments);
        this.navRef = React.createRef();
        this.componentDidMount = () => {
            this.updateProps({});
        };
        this.componentDidUpdate = (oldProps) => {
            this.updateProps(oldProps);
        };
        this.updateProps = (oldProps = {}) => {
            const { items = {}, onSelect, onToggleCollapse, onOpenStateChange, openStates, } = this.props;
            const { items: oldItems, onSelect: oldOnSelect, onToggleCollapse: oldOnToggleCollapse, onOpenStateChange: oldOnOpenStateChange, openStates: oldOpenStates, } = oldProps;
            const nav = this.navRef.current;
            if (!!nav) {
                if (items !== oldItems) {
                    nav.items = items;
                }
                if (onSelect !== oldOnSelect) {
                    nav.onSelect = onSelect;
                }
                if (onToggleCollapse !== oldOnToggleCollapse) {
                    nav.onToggleCollapse = onToggleCollapse;
                }
                if (onOpenStateChange !== oldOnOpenStateChange) {
                    nav.onOpenStateChange = onOpenStateChange;
                }
                if (openStates !== oldOpenStates) {
                    nav.openStates = openStates;
                }
            }
        };
    }
    render() {
        const _a = this.props, { gutter, collapsible, collapsed, grid, subHeaderBorder, alwaysShowBordersTop, alwaysShowBordersBottom, bubbleBottomItems, style: stylesProp, items, onSelect, customHeader, customExpandedHeader, subHeader, onToggleCollapse } = _a, otherProps = __rest(_a, ["gutter", "collapsible", "collapsed", "grid", "subHeaderBorder", "alwaysShowBordersTop", "alwaysShowBordersBottom", "bubbleBottomItems", "style", "items", "onSelect", "customHeader", "customExpandedHeader", "subHeader", "onToggleCollapse"]);
        let sideNavProps = otherProps;
        if (!!gutter)
            sideNavProps.gutter = gutter;
        if (!!collapsible)
            sideNavProps.collapsible = collapsible;
        if (!!collapsed)
            sideNavProps.collapsed = collapsed;
        if (!!grid)
            sideNavProps.grid = grid;
        if (!!subHeaderBorder)
            sideNavProps.subHeaderBorder = subHeaderBorder;
        if (!!alwaysShowBordersTop)
            sideNavProps.alwaysShowBordersTop = alwaysShowBordersTop;
        if (!!alwaysShowBordersBottom)
            sideNavProps.alwaysShowBordersBottom = alwaysShowBordersBottom;
        if (!!bubbleBottomItems)
            sideNavProps.bubbleBottomItems = bubbleBottomItems;
        return (React.createElement("unity-global-nav-base", Object.assign({ ref: this.navRef, style: stylesProp }, sideNavProps),
            !!customHeader &&
                React.createElement("span", { slot: "customHeader" }, customHeader),
            !!customExpandedHeader &&
                React.createElement("span", { slot: "customExpandedHeader" }, customExpandedHeader),
            !!subHeader &&
                React.createElement("span", { slot: "subHeader" }, subHeader)));
    }
}
